///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import ignoreNullValues from "./ignoreNullValues";

import messages from "./messages";

const getSearchAllBidsParams = state => {
  const params = {
    searchTerm: state.searchTerm,
    modes: state.modes.map(x => x.value),
    status: state.status
      .filter(
        x =>
          x.label !== messages.awarded.defaultMessage &&
          x.label !== messages.lost.defaultMessage &&
          x.label !== messages.archived.defaultMessage
      )
      .map(y => y.value),
    awardStatus: state.status
      .filter(
        x =>
          x.label === messages.awarded.defaultMessage ||
          x.label === messages.lost.defaultMessage
      )
      .map(y => y.value),
    isArchived: state.status.some(
      x => x.label === messages.archived.defaultMessage
    ),
    sortColumn: state.sortColumn,
    sortOrder: state.sortOrder,
    pageNumber: state.pageNumber,
    pageLength: state.limit
  };

  return ignoreNullValues(params);
};

export default getSearchAllBidsParams;
